<t4-container>
  <div class="row">
    <div class="col-8">
      <mat-form-field style="width: auto;" appearance="outline">
        <mat-label>{{'Turbo.Core.PeriodPicker.lblFrom' |translate : 'From' }}</mat-label>
        <input matInput [matDatepicker]="dp" (dateChange)="selectFromDate($event, dp)" [formControl]="txtFromDate">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="year" (yearSelected)="selectFromYear($event, dp)" (monthSelected)="selectFromMonth($event, dp)"></mat-datepicker>
      </mat-form-field>
      <mat-form-field  style="margin-left: 5px; width: auto;" appearance="outline">
        <mat-label>{{'Turbo.Core.PeriodPicker.lblTo' |translate : 'To' }}</mat-label>
        <input matInput [matDatepicker]="dpTo" (dateChange)="selectToDate($event, dpTo)" [formControl]="txtToDate">
        <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
        <mat-datepicker #dpTo startView="year" (yearSelected)="selectToYear($event, dpTo)" (monthSelected)="selectToMonth($event, dpTo)"></mat-datepicker>
      </mat-form-field>
      <button mat-button color="primary" (click)="update()" style="margin-left: 5px;">Update</button>
    </div>
    <div class="col-4" style="text-align: right; padding-top:12px;">
      <button mat-button (click)="previous()"><mat-icon>navigate_before</mat-icon></button>
      <button mat-button (click)="next()"><mat-icon>navigate_next</mat-icon></button>
    </div>
  </div>
</t4-container>
